import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import {
  NavBar,
  ButtonIconContextual,
  LoaderIndicator
} from '@warrenbrasil/nebraska-web';
import RegulatoryUpdatePersonalData from '@/modules/account/views/RegulatoryUpdate/views/RegulatoryUpdatePersonalData/RegulatoryUpdatePersonalData.vue';
import {
  goToNextRoute,
  goToPreviousRoute
} from '@/modules/common/store/RegulatoryUpdateRoutesOrchestrator';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';


export default /*#__PURE__*/_defineComponent({
  __name: 'RegulatoryUpdatePersonalRegister',
  setup(__props) {

const isLoading = ref(true);

function back() {
  goToPreviousRoute();
}

function setIsLoading(loading: boolean) {
  isLoading.value = loading;
}

function notifyError() {
  notify({
    group: 'wrn-notifications',
    text: 'Houve um problema ao salvar seus dados. Aguarde alguns instantes e tente novamente.',
    type: NotificationTypes.error
  });
}

return { __sfc: true,isLoading, back, setIsLoading, notifyError, NavBar, ButtonIconContextual, LoaderIndicator, RegulatoryUpdatePersonalData, goToNextRoute }
}

})